// Screen addresses: screen-routes.json, a copy of api/src/Shared/ScreenRoutes/screen-routes.json
// Edit both in one commit; no raw path elsewhere.
import mirror from './screen-routes.json';

const screens = Object.assign({}, ...Object.values(mirror));

export function screenPath(name) {
  const path = screens[name];

  if (!path) throw new Error(`Unknown screen route: ${name}`);

  return path;
}

export function screen(name) {
  return { name, path: screenPath(name) };
}

export function screenPrefix(name) {
  const segments = screenPath(name).split('/').filter(Boolean);
  const firstParam = segments.findIndex((segment) => segment.startsWith(':'));

  return `/${(firstParam < 0 ? segments : segments.slice(0, firstParam)).join('/')}`;
}
